import React from 'react';
import { Text, View } from 'react-native';
import { font } from '@styles/fonts';
import { scale } from '@components/frame';
import i18n from 'i18n-js';
import { getBoxShadowStyle } from '@styles/shadow';
import InputLine from '@components/machines/components/detailsComponents/activeMachine/components/InputLine';
import { BatchFieldItemProps } from './types';
import { SCREEN_BORDER_RADIUS } from '@v2/pages/common/constants/base.constants';

const ProductivityBlockWithTimelines = ({
  data,
  C,
  label,
  listHeight = scale(42),
  onlyLabel,
  labelAlreadyTranslated,
  children,
}: BatchFieldItemProps) => {
  const roundTopConfig = {
    borderRadius: scale(SCREEN_BORDER_RADIUS),
  };

  return (
    <View style={{ marginTop: scale(26) }}>
      {label ? (
        <Text style={[font.Body, { color: C('Label/Light/Tertiary'), paddingHorizontal: scale(15), marginBottom: scale(5) }]}>
          {labelAlreadyTranslated ? label : i18n.t(label)}
        </Text>
      ) : null}
      <View style={[{ width: '100%', height: listHeight * data.length }, roundTopConfig, getBoxShadowStyle({ type: 'Field', C })]}>
        {data.map((i, index) => (
          <InputLine
            {...{
              borderBottomRadius: data.length - 1 === index,
              borderTopRadius: index === 0,
              data,
              onlyLabel,
              index,
              i,
              C,
              key: i.key,
              loading: false,
            }}
          />
        ))}
      </View>
      {children}
    </View>
  );
};

export default ProductivityBlockWithTimelines;
